export let RELEASE_STATUS = {false:"公開中", true:"非公開"}
export let SEND_MAIL_STATUS = {0:"送信中", 1:"送信完了", 2:"エラーあり", 3:"対応済"}